import React from 'react';
import {
  Card,
  Grid,
  CardContent,
  CardHeader,
  Divider,
} from '@mui/material';

import {
  Datagrid,
  TextField,
  ArrayField,
  useRecordContext,
} from 'react-admin';

import { boldDataGridStyle } from '../../../../constants/style/datagridStyles';

import ReferenceEntityField from '../../../../customFields/ReferenceEntityField';
import ColoredScoreField from '../../../../customFields/ColoredScoreField';
import EntityDisplayNameField from '../../../../customFields/EntityDisplayNameField';

const BusinessKyc = () => {
  const record = useRecordContext();
  if (!record) return null;

  const { extraInformation } = record;

  const reformedEntities = {
    entities: [
      {
        id: extraInformation?.entity?.id,
        type: extraInformation?.entity?.type,
      },
    ].filter((item) => item?.id),
  };

  return (
    <Grid size={12}>
      <Grid container spacing={6}>
        <Grid size={12}>
          <Card variant="outlined">
            <CardHeader title="Business KYC request details" />
            <Divider />
            <CardContent>
              <Card variant="outlined">
                <CardHeader title="Involved entities" />
                <Divider />
                <ArrayField record={reformedEntities} source="entities">
                  <Datagrid sx={boldDataGridStyle} bulkActionButtons={false}>
                    <ReferenceEntityField source="" label="Name">
                      <EntityDisplayNameField />
                    </ReferenceEntityField>
                    <TextField emptyText="-" source="type" label="Type" />
                    <ReferenceEntityField source="" label="Risk score">
                      <ColoredScoreField source="riskScore" />
                    </ReferenceEntityField>
                  </Datagrid>
                </ArrayField>
              </Card>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BusinessKyc;
